export class ProjectType {
    title: string;
    color = 0;
    id = 0;
}
